module.exports = __webpack_public_path__ + "img/success.348fc47f.svg";